/**
 * Responsive utilities - matches Angular APPLICANT_PANEL_RESPONSIVE_README
 * Mobile: viewport 320px–768px
 * Desktop: viewport > 768px
 */

export const MOBILE_MAX_WIDTH = 768;

/**
 * Returns true if viewport is in mobile range (320px–768px).
 * Used for list/grid toggle, sidebar drawer, etc.
 */
export function isMobileBrowser(): boolean {
  if (typeof window === "undefined") return false;
  return window.innerWidth >= 320 && window.innerWidth <= MOBILE_MAX_WIDTH;
}

/**
 * Breakpoints matching the README (for reference in Tailwind):
 * 320–449px: Small phones
 * 450–767px: Phones / large phones
 * 768px: Tablet start
 * 768–1023px: Tablets
 * 1024px: Small desktop
 * 1024–1280px: Desktop
 * 1280px+: Large desktop
 */
export const BREAKPOINTS = {
  xs: 320,
  sm: 450,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const;
